import { useAuth } from "../auth/AuthContext";

export default function Topbar({
  sidebarOpen,
  setSidebarOpen,
}) {
  const { logout } = useAuth();

  return (
    <header className="fixed top-0 left-0 right-0 lg:left-64 z-30 bg-white shadow h-16">
      <div className="h-full flex items-center justify-between px-4 sm:px-6">
        
        {/* Mobile Hamburger */}
        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="lg:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-100"
          aria-label="Open menu"
        >
          <div className="space-y-1.5">
            <span className="block w-6 h-0.5 bg-gray-800"></span>
            <span className="block w-6 h-0.5 bg-gray-800"></span>
            <span className="block w-6 h-0.5 bg-gray-800"></span>
          </div>
        </button>

        {/* Mobile Title */}
        <div className="lg:hidden text-lg font-bold text-gray-800">
          Admin
        </div>

        {/* Logout */}
        <button
          onClick={logout}
          className="text-red-600 font-semibold text-sm sm:text-base"
        >
          Logout
        </button>
      </div>
    </header>
  );
}